import { useRef, useState } from "react";
import { Textarea } from "@/components/ui/textarea";

const escRe = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
export const mentionsIn = (text, people) => people.filter((p) => new RegExp(`@${escRe(p.name)}(?![\\w])`).test(text)).map((p) => p.user_id);

export const MentionText = ({ body, mentions = [] }) => {
  if (!mentions.length) return body;
  const names = [...new Set(mentions.map((m) => m.name))].sort((a, b) => b.length - a.length).map(escRe);
  return body.split(new RegExp(`(@(?:${names.join("|")})(?![\\w]))`, "g")).map((part, i) => (i % 2
    ? <span key={i} className="rounded px-0.5 bg-amber-500/10 text-amber-300 font-medium" data-testid="comment-mention">{part}</span> : part));
};

const Avatar = ({ p }) => (
  <span className="h-6 w-6 shrink-0 rounded-full bg-amber-500/15 border border-amber-500/30 text-amber-200 text-[10px] font-semibold flex items-center justify-center overflow-hidden">
    {p.picture ? <img src={p.picture} alt="" className="h-full w-full object-cover" /> : p.name.slice(0, 2).toUpperCase()}
  </span>
);

export const MentionInput = ({ value, onChange, people, testId, placeholder }) => {
  const ref = useRef(null);
  const [q, setQ] = useState(null);
  const [hi, setHi] = useState(0);
  const update = (v, caret) => {
    onChange(v);
    const m = v.slice(0, caret).match(/(^|\s)@([^\s@]{0,30})$/);
    setQ(m ? { start: caret - m[2].length - 1, text: m[2].toLowerCase() } : null);
    setHi(0);
  };
  const opts = q ? people.filter((p) => p.name.toLowerCase().includes(q.text)).slice(0, 6) : [];
  const pick = (p) => {
    const caret = ref.current.selectionStart;
    const pos = q.start + p.name.length + 2;
    onChange(`${value.slice(0, q.start)}@${p.name} ${value.slice(caret)}`);
    setQ(null);
    requestAnimationFrame(() => { ref.current?.focus(); ref.current?.setSelectionRange(pos, pos); });
  };
  const onKeyDown = (e) => {
    if (!opts.length) return;
    if (e.key === "ArrowDown" || e.key === "ArrowUp") { e.preventDefault(); setHi((h) => (h + (e.key === "ArrowDown" ? 1 : opts.length - 1)) % opts.length); }
    else if (e.key === "Enter" || e.key === "Tab") { e.preventDefault(); pick(opts[hi]); }
    else if (e.key === "Escape") setQ(null);
  };
  return (
    <div className="relative">
      <Textarea ref={ref} value={value} rows={2} placeholder={placeholder} onKeyDown={onKeyDown} onBlur={() => setTimeout(() => setQ(null), 150)}
        onChange={(e) => update(e.target.value, e.target.selectionStart)} className="bg-inset border-line text-sm" data-testid={`${testId}-input`} />
      {opts.length > 0 && (
        <div className="absolute z-30 left-0 top-full mt-1 w-64 rounded-lg border border-line bg-panel shadow-xl py-1" data-testid={`${testId}-mentions`}>
          {opts.map((p, i) => (
            <button key={p.user_id} type="button" onMouseDown={(e) => { e.preventDefault(); pick(p); }}
              className={`flex w-full items-center gap-2 px-3 py-1.5 text-left text-sm transition-colors ${i === hi ? "bg-amber-500/10 text-amber-200" : "text-slate-300 hover:bg-veil/5"}`} data-testid={`mention-option-${p.user_id}`}>
              <Avatar p={p} /><span className="truncate">{p.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
